"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// instanbul ignore file
var index_1 = tslib_1.__importDefault(require("../../Config/index"));
var index_2 = require("../../modules/authorize/index");
var interfaces_1 = require("../../modules/authorize/interfaces");
var axios_1 = tslib_1.__importDefault(require("axios"));
var constants_1 = require("../../modules/authorize/constants");
var LogError_1 = require("../LogError");
var authParamsMap = {
    accessToken: "X-CHEGG-ACCESS-TOKEN",
    idToken: "X-CHEGG-ID-TOKEN",
    csrfToken: "X-CHEGG-CSRF-TOKEN",
    apiKey: "X-CHEGG-CHECKOUTSDK-API-KEY",
    noCookie: "X-CHEGG-NO-COOKIES",
};
var BaseApi = /** @class */ (function () {
    function BaseApi() {
    }
    /**
     * doPostRequestToChegg: provides abstraction for calls to chegg ajax endpoints,
     *      since we often have to attach cookies and additional fields to the query.
     */
    /* istanbul ignore next */
    BaseApi.doPostRequestToChegg = function (uri, params, extraAuthParams, timeout) {
        if (extraAuthParams === void 0) { extraAuthParams = null; }
        if (timeout === void 0) { timeout = 30000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var APIBaseUrl, headers, errorData_1, payload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        APIBaseUrl = index_2.cheggBaseUrl
                            ? /* istanbul ignore next */ index_2.cheggBaseUrl
                            : index_1.default.cheggBaseUrl;
                        headers = this.getHeaders(extraAuthParams);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.request({
                                url: "".concat(APIBaseUrl).concat(uri),
                                method: "POST",
                                data: params,
                                timeout: timeout,
                                headers: headers,
                                withCredentials: this.getWithCredentials(),
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        errorData_1 = _a.sent();
                        payload = {
                            passport: headers["CHEGG-PASSPORT"],
                            isInternal: true,
                            pageUrl: headers["X-CHEGG-PAGE-URL"],
                        };
                        this.handleException(errorData_1, undefined, true, payload);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /*
     * Function to get Current Domain Url
     * Samples:
     *      "https://domain.sharepoint.com"
     */
    BaseApi.getAbsoluteDomainUrl = function () {
        /* istanbul ignore next */
        if (typeof window != "undefined") {
            // test already added
            if (window &&
                "location" in window &&
                "protocol" in window.location &&
                "host" in window.location) {
                return window.location.protocol + "//" + window.location.host;
            }
        }
        else {
            // bff environment
            /* istanbul ignore next */
            return index_2.cheggOrigin;
        }
        return "";
    };
    BaseApi.handleException = function (errorData, operationName, logError, internalRequestPayload) {
        var _a, _b, _c;
        var errorMessage = errorData.message;
        var apiError;
        if ((_a = errorData.response) === null || _a === void 0 ? void 0 : _a.status) {
            switch (errorData.response.status) {
                case 403:
                    errorMessage = "AUTHORIZE_FAILURE";
                    break;
                case 400:
                    errorMessage = "BAD_REQUEST";
                    break;
                case 500:
                    errorMessage = "INTERNAL_SERVER_ERROR";
                    break;
            }
        }
        if (constants_1.AuthorizeErrors[errorMessage]) {
            apiError = constants_1.AuthorizeErrors[errorMessage];
        }
        else {
            apiError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
            var uri = operationName ? "graphql:".concat(operationName) : operationName;
            if (!uri) {
                var url = (_c = (_b = errorData.config) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : "_ajax/urlNotFound";
                uri = url.substring(url.indexOf("_ajax"), url.indexOf("?") !== -1 ? url.indexOf("?") : url.length);
            }
            apiError.message = "".concat(uri, ":").concat(errorMessage);
        }
        var response = {
            errors: [apiError],
            data: null,
            success: false,
        };
        if (logError) {
            (0, LogError_1.logErrorToNR)(response, internalRequestPayload);
        }
        throw new Error(JSON.stringify(response));
    };
    /* istanbul ignore next */
    BaseApi.getWithCredentials = function () {
        return (index_2.authorizeParams === null || index_2.authorizeParams === void 0 ? void 0 : index_2.authorizeParams.noCookie) ? false : true;
    };
    BaseApi.getHeaders = function (extraAuthParams) {
        if (extraAuthParams === void 0) { extraAuthParams = null; }
        var headers = {
            "content-type": "application/json;charset=UTF-8",
            "X-CHEGG-CHECKOUTSDK-API-KEY": "unknown",
            "X-CHEGG-ORIGIN": BaseApi.getAbsoluteDomainUrl(), // GCE-4784. We will start relying on x-chegg-origin instead of origin
        };
        var authParams = index_2.authorizeParams || {
            apiKey: "unknown",
        };
        var skipFields = [];
        if (extraAuthParams) {
            if (extraAuthParams.skipCsrfToken) {
                skipFields.push("csrfToken");
            }
            if (extraAuthParams.loggedInState) {
                switch (extraAuthParams.loggedInState) {
                    case interfaces_1.LoggedInState.SOFT:
                        skipFields.push("accessToken");
                        break;
                    case interfaces_1.LoggedInState.LOGGED_OUT:
                        skipFields.push("accessToken");
                        skipFields.push("idToken");
                        break;
                }
            }
        }
        Object.keys(authParams).forEach(function (key) {
            if (skipFields.indexOf(key) === -1 &&
                authParamsMap[key] &&
                authParams[key]) {
                headers[authParamsMap[key]] = authParams[key];
            }
        });
        return headers;
    };
    return BaseApi;
}());
exports.default = BaseApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/API/BaseApi/index.js
// module id = 831
// module chunks = 11